import PayrollSettingComponent from "../components/PayrollSetting";
import usePayroll from "../hooks/usePayroll";

const PayrollSetting = () => {
  const PayrollProps = usePayroll();
  return <PayrollSettingComponent {...PayrollProps} />;
};

export default PayrollSetting;
